// Widget Scripts
import customSignupFeature from './js/customSignupFeature';

// Custom Theme Scripts
import './js/localjs.js';



// Initialize Homepage Widgets if is required
if (globalThis.location.pathname === '/') {
    $(document).ready(function () {
    });

};

$(document).ready(function () {
    customSignupFeature();
});
